"use strict";
/**
 * This file was auto generated, please do not edit it directly.
 **/

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Import = void 0;

var Import =
/** @class */
function () {
  function Import(restClient) {
    this.restClient = restClient;
  } // Queries

  /**
   * @param string - healthPassImportId
   * @param string[]? - withData GoodRecords|DuplicateRecords|ErrorRecords|ImportFailureRecords
   * @return Promise|Observable|any
   */


  Import.prototype.GetHealthPassImport = function (healthPassImportId, withData) {
    if (withData === void 0) {
      withData = null;
    }

    return this.restClient.get('Import/UseCase/GetHealthPassImport', {
      healthPassImportId: healthPassImportId,
      withData: withData
    });
  };
  /**
   * @param string - healthPassImportId
   * @param string - fileId
   * @return Promise|Observable|any
   */


  Import.prototype.GetHealthPassImportFile = function (healthPassImportId, fileId) {
    return this.restClient.get('Import/UseCase/GetHealthPassImportFile', {
      healthPassImportId: healthPassImportId,
      fileId: fileId
    }, null, {
      responseType: 'text'
    });
  };
  /**
   * @param string - userImportId
   * @param string[]? - withData GoodRecords|DuplicateRecords|ErrorRecords|ImportFailureRecords
   * @return Promise|Observable|any
   */


  Import.prototype.GetUserImport = function (userImportId, withData) {
    if (withData === void 0) {
      withData = null;
    }

    return this.restClient.get('Import/UseCase/GetUserImport', {
      userImportId: userImportId,
      withData: withData
    });
  };
  /**
   * @param string - userImportId
   * @param string - fileId
   * @return Promise|Observable|any
   */


  Import.prototype.GetUserImportFile = function (userImportId, fileId) {
    return this.restClient.get('Import/UseCase/GetUserImportFile', {
      userImportId: userImportId,
      fileId: fileId
    }, null, {
      responseType: 'text'
    });
  }; // Commands

  /**
   * @param string - userImportId
   * @param string - eventId
   * @param string? - stackId
   * @param number? - guestsPerInvitation >= 1
   * @param string? - invitationCreationType unconfirmed-no-email|confirmed-no-email|send-email
   * @param string? - groupName
   * @param string? - groupId
   * @param string? - redirectUrl
   * @return Promise|Observable|any
   */


  Import.prototype.PostProcessAndImportInvitations = function (userImportId, eventId, stackId, guestsPerInvitation, invitationCreationType, groupName, groupId, redirectUrl) {
    if (stackId === void 0) {
      stackId = null;
    }

    if (guestsPerInvitation === void 0) {
      guestsPerInvitation = null;
    }

    if (invitationCreationType === void 0) {
      invitationCreationType = null;
    }

    if (groupName === void 0) {
      groupName = null;
    }

    if (groupId === void 0) {
      groupId = null;
    }

    if (redirectUrl === void 0) {
      redirectUrl = null;
    }

    return this.restClient.post('Import/UseCase/PostProcessAndImportInvitations', {
      userImportId: userImportId,
      eventId: eventId,
      stackId: stackId,
      guestsPerInvitation: guestsPerInvitation,
      invitationCreationType: invitationCreationType,
      groupName: groupName,
      groupId: groupId,
      redirectUrl: redirectUrl
    });
  };
  /**
   * @param string - userImportId
   * @param string? - groupName
   * @param string? - groupId
   * @param string? - redirectUrl
   * @return Promise|Observable|any
   */


  Import.prototype.PostProcessAndImportUsers = function (userImportId, groupName, groupId, redirectUrl) {
    if (groupName === void 0) {
      groupName = null;
    }

    if (groupId === void 0) {
      groupId = null;
    }

    if (redirectUrl === void 0) {
      redirectUrl = null;
    }

    return this.restClient.post('Import/UseCase/PostProcessAndImportUsers', {
      userImportId: userImportId,
      groupName: groupName,
      groupId: groupId,
      redirectUrl: redirectUrl
    });
  };
  /**
   * @param string - userId
   * @param string - poolId
   * @param any - spreadsheet
   * @return Promise|Observable|any
   */


  Import.prototype.PreProcessSpreadsheetForUserImport = function (userId, poolId, spreadsheet) {
    return this.restClient.postMultipart('Import/UseCase/PreProcessSpreadsheetForUserImport', {
      userId: userId,
      poolId: poolId,
      spreadsheet: spreadsheet
    });
  };

  return Import;
}();

exports.Import = Import;